"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.IdeationPermissions = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _logger = require("@insided/shared/services/logger");

var _header = _interopRequireDefault(require("../header"));

var _Table = _interopRequireDefault(require("@insided/deprecated-preact-components/table/Table"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _axios = _interopRequireDefault(require("axios"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var IdeationPermissions = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(IdeationPermissions, _Component);

  var _super = _createSuper(IdeationPermissions);

  function IdeationPermissions(props) {
    var _this;

    (0, _classCallCheck2.default)(this, IdeationPermissions);
    _this = _super.call(this, props);
    var primary = [];
    var custom = [];
    props.permissions.forEach(function (permission) {
      if (permission.custom) {
        custom.push(permission);
      } else {
        primary.push(permission);
      }
    }); // eslint-disable-next-line react/state-in-constructor

    _this.state = {
      primary: primary,
      custom: custom,
      isLoading: false,
      messageType: null
    };
    _this.updatePermission = _this.updatePermission.bind((0, _assertThisInitialized2.default)(_this));
    _this.saveChanges = _this.saveChanges.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(IdeationPermissions, [{
    key: "updatePermission",
    value: function updatePermission(key, idx, newValue) {
      // eslint-disable-next-line react/no-access-state-in-setstate
      var newList = this.state[key].concat([]);
      newList[idx].permission = newValue; // @ts-expect-error

      this.setState((0, _defineProperty2.default)({}, key, newList));
    }
  }, {
    key: "saveChanges",
    value: function () {
      var _saveChanges = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  isLoading: true,
                  messageType: null
                });
                _context.prev = 1;
                _context.next = 4;
                return _axios.default.post('/platform/ideation/permissions', {
                  permissions: this.state.primary.concat(this.state.custom)
                });

              case 4:
                this.setState({
                  isLoading: false,
                  messageType: 'success'
                });
                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);

                _logger.logger.error(_context.t0, {
                  component: 'IdeationPermissions',
                  action: 'saveChanges'
                });

                this.setState({
                  isLoading: false,
                  messageType: 'error'
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 7]]);
      }));

      function saveChanges() {
        return _saveChanges.apply(this, arguments);
      }

      return saveChanges;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          primary = _this$state.primary,
          custom = _this$state.custom,
          isLoading = _this$state.isLoading,
          messageType = _this$state.messageType;
      var primaryModel = [{
        header: 'Default role',
        accessor: 'role'
      }, {
        header: (0, _preact.h)("span", null, "Access to ideation", ' ', (0, _preact.h)(_Tooltip.default, {
          trigger: (0, _preact.h)("i", {
            className: "fa fa-question-circle"
          }),
          tooltipMessage: "User can view, create, reply and vote for ideas",
          noWrap: true
        })),
        accessor: 'action'
      }];
      var primaryRows = primary.map(function (permissionInfo, idx) {
        return {
          role: permissionInfo.title,
          action: (0, _preact.h)(_InputGroup.default, {
            type: "checkbox",
            checked: permissionInfo.permission,
            onChangeCheckbox: function onChangeCheckbox() {
              return _this2.updatePermission('primary', idx, !permissionInfo.permission);
            }
          })
        };
      });
      var customModel = [{
        header: 'Custom role',
        accessor: 'role'
      }, {
        header: (0, _preact.h)("span", null, "Access to ideation", ' ', (0, _preact.h)(_Tooltip.default, {
          trigger: (0, _preact.h)("i", {
            className: "fa fa-question-circle"
          }),
          tooltipMessage: "User can view, create, reply and vote for ideas",
          noWrap: true
        })),
        accessor: 'action'
      }];
      var customRows = custom.map(function (permissionInfo, idx) {
        return {
          role: permissionInfo.title,
          action: (0, _preact.h)(_InputGroup.default, {
            type: "checkbox",
            checked: permissionInfo.permission,
            onChangeCheckbox: function onChangeCheckbox() {
              return _this2.updatePermission('custom', idx, !permissionInfo.permission);
            }
          })
        };
      });
      return (0, _preact.h)("div", {
        className: "ideation-platform-page"
      }, (0, _preact.h)(_header.default, {
        isLoading: isLoading,
        title: "Permissions Settings",
        saveCallback: function saveCallback() {
          return _this2.saveChanges();
        },
        hasBreadcrumb: true,
        breadcrumbText: "Ideation",
        breadcrumbLink: "/platform/ideation"
      }), messageType ? (0, _preact.h)(_AlertComponent.default, {
        sticky: true,
        messageType: messageType,
        isVisibleFor: 3000
      }) : null, (0, _preact.h)(_Table.default, {
        model: primaryModel,
        rows: primaryRows
      }), custom.length ? (0, _preact.h)(_Table.default, {
        model: customModel,
        rows: customRows
      }) : null);
    }
  }]);
  return IdeationPermissions;
}(_preact.Component);

exports.IdeationPermissions = IdeationPermissions;
var _default = IdeationPermissions;
exports.default = _default;